module.exports = __webpack_public_path__ + "img/AMEX.c2fb6a8a.svg";